// extracted by mini-css-extract-plugin
module.exports = {"section":"sidebar_section__3oCdy","list":"sidebar_list__1z_RJ","link":"sidebar_link__3XNb6","transform":"sidebar_transform__1RYvi"};